export default {
  estaCarregando: false,
  todosItensCarregados: true,
  totalItens: 0,
  listaMenus: [],
  menuCarregado: false,
  permissaoModuloId: null,
  listaFavoritos: [],
  favoritoSelecionadoId: null,
  objFavorito: {
    modulo: ''
  },
  usuarioLogado: {},
  rotaAtual: null,
  franqueadaSelecionada: null,
  showBreadcrumbs: true
}
